import {TweenMax, ScrollToPlugin, Circ} from 'gsap/all';
const CustomEase = require('gsap/CustomEase');
import inView from 'in-view';

[ScrollToPlugin];

import Swiper from '../../../../../node_modules/swiper/dist/js/swiper';
const SizeMode = require('./utils/SizeMode');
const SizesUtils = require('../../viscomjs/utils/SizesUtils');
const InViewOffMixin = require('../../viscomjs/utils/InViewOffMixin');
const analyticsEvent = require('../../viscomjs/analytics/analyticsEvent');
const ParallaxController = require('./components/ParallaxController');
const WM = require('./BOSSWatermarkSingleton');
const win = window;
let mainSW;
let longSW;
let staticView;
let started = false;
let isLong = false;
let isVertical = false;
let sizeMode = false;
let currIndex = 0;
let prevIndex = -1;
let tweenFunc = undefined;
let swInitiated = false;
let staticInitiated = false;
let scrollTransition = false;
let _hasOnChange = false;
let _onChange = undefined;
let _hasOnLongProgressChanged = false;
let _onLongProgressChanged = undefined;
let _H = 0;
const _delta = 1720;


function init() {

    const SWShortStepKeyboard = require('./components/SWShortStepKeyboard');
    Swiper.use([SWShortStepKeyboard]);

    _H = SizesUtils.winHeight();
    sizeMode = SizeMode(true);
    isVertical = sizeMode === 'vertical';

    if (sizeMode !== 'static') {
        _initSWs();
        return this;
    }

    _initStatic();
    _goto(currIndex);
    return this;
}

function _initSWs() {
    if (swInitiated) return this;

    _allow = swAllow;
    _next = swNext;
    _goto = swGoto;
    _scrollLong = swScrollLong;

    scrollTransition = false;

    const longSWConfig = {
        direction: sizeMode,
        speed: 750,
        spaceBetween: 0,
        transforms3d: true,
        touchMoveStopPropagation: false,
        wrapperClass: 'section__wrap',
        touchEventsTarget: 'container',
        slidesPerView: 'auto',
        virtualTranslate: true,
        nested: true,
        forceToAxis: true,

        freeMode: true,
        freeModeMomentumVelocityRatio: 0.7,
        scrollbar: {
            el: '.swiper-scrollbar'
        },
        mousewheel: {
            enabled: true,
            sensitivity: 2,
            releaseOnEdges: true
        },
        shortStepKeyboard: {
            enabled: true,
            onlyInViewport: true,
            ratio: 0.8
        }
    };

    longSW = new Swiper('.section--type-long', longSWConfig);

    const mainSWConfig = {
        // loop: true,
        speed: 1050,
        spaceBetween: 0,
        transforms3d: true,
        touchMoveStopPropagation: false,
        followFinger: false,
        // wrapperClass: 'sections__container',
        touchEventsTarget: 'wrapper',
        slidesPerView: 'auto',
        virtualTranslate: true,
        forceToAxis: true,

        mousewheel: {
            enabled: true,
            sensitivity: 2
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }

    };

    mainSW = new Swiper('.sections', mainSWConfig);

    const _baseSetTransition = mainSW.setTransition.bind(mainSW);
    const _baseSetTranslate = mainSW.setTranslate.bind(mainSW);
    mainSW.vertualTranslateObj = {x: mainSW.translate};
    mainSW.setTransition = function (duration, byController) {
        _baseSetTransition(0, byController);
    };
    mainSW.setTranslate = function (translate, byController) {
        _baseSetTranslate(translate, byController); // console.log('translate')
        TweenMax.killTweensOf(mainSW.vertualTranslateObj); let lastX = undefined;
        TweenMax.to(mainSW.vertualTranslateObj, mainSW.params.speed / 1000, {
            x: mainSW.translate,
            ease: CustomEase.create('custom', 'M0,0,C0.3,0,0.2,1,1,1'),
            onStart: function () {
                scrollTransition = true;
                mainSW.transitionStart();
            },
            onUpdate: function () {
                const x = this.target.x;
                if (typeof lastX === 'undefined') lastX = x;
                WM.setWrapTotalShift(x);
                mainSW.$wrapperEl.transform('translate3d(' + lastX + 'px, 0px, 0px)');
                lastX = x;
                ParallaxController.update();
            },
            onComplete: function () {
                mainSW.$wrapperEl.transform('translate3d(' + lastX + 'px, 0px, 0px)');
                mainSW.transitionEnd();

                scrollTransition = false;

                if (!isLong) {
                    const s = mainSW.slides[prevIndex];
                    ParallaxController.stop(s);
                }

                longSW.forEach(sw => {
                    sw.el.data.lastProgressN = 0;
                });
            }
        });
    };
    mainSW.on('slideChange', () => {
        const section = mainSW.slides[mainSW.activeIndex];

        // TODO: send title instead of index
        analyticsEvent('Page', 'change', 'Section: ' + section.dataset.eventLabel);
        // console.log('Page', 'change', 'Section: ' + section.dataset.eventLabel);


        isLong = section.classList.contains('section--type-long');
        const scrollOn = !isLong;
        mainSW.allowSlideNext = scrollOn || isVertical;
        mainSW.allowSlidePrev = scrollOn || isVertical;
        // console.log(mainSW.realIndex, isLong, mainSW.allowSlideNext, mainSW.allowSlidePrev)

        longSW.forEach(sw => {
            sw.shortStepKeyboard.allowSlideNext = isLong;
            sw.shortStepKeyboard.allowSlidePrev = isLong;
        });

        longSW.mouseEntered = true;
        mainSW.mouseEntered = true;

        prevIndex = currIndex;
        currIndex = mainSW.realIndex;

        if (isLong) {
            ParallaxController.init(section);
        } else {
            if (isVertical)
                longSW.forEach(sw => {
                    sw.slideTo(0);
                });
        }

        _emitChanged(mainSW.realIndex, prevIndex);

    });

    mainSW.on('beforeDestroy', () => {
        const section = mainSW.slides[mainSW.activeIndex];
        isLong = section.classList.contains('section--type-long');
        if (isLong) {
            ParallaxController.stop(section);
        }

        if (mainSW.vertualTranslateObj) {
            TweenMax.killTweensOf(mainSW.vertualTranslateObj);
        }
    });

    longSW.forEach((sw, index) => {

        const label = sw.el.dataset.eventLabel;

        let data = sw.el.data;

        if (!data) {
            data = {};
            _initScrollState(data);
        }

        data.sw = sw;

        sw.el.data = data;

        sw.on('progress', p => {

            _updateScrollState(data, p * 100);
            if (data.scrollFixedProgressChanged) {
                analyticsEvent(`"${label}" Scroll Depth Percentage`, 'scroll', data.scrollFixedProgress);
                // console.log(`"${label}" Scroll Depth Percentage`, 'scroll', data.scrollFixedProgress);
                data.scrollFixedProgressChanged = false;
            }

            sw.el.data.lastProgress = p;

            _emitLongProgressChanged(index, sw.progress);

            if (isVertical) return;
            if (isLong) {
                mainSW.allowSlideNext = p > 0.99;
                mainSW.allowSlidePrev = p < 0.01; // console.log('Long', isLong, mainSW.allowSlideNext, mainSW.allowSlidePrev)
            }

            if (p < 1) {
                sw.el.data.lastProgressN = 0;
                return;
            }

            if (sw.el.data.lastProgress !== p) {
                sw.el.data.lastProgressN = 0;
                mainSW.mouseEntered = true;
            }
            if (sw.el.data.lastProgress === p) {
                sw.el.data.lastProgressN++;
            }
        });

        sw.on('beforeDestroy', () => {
            if (sw.vertualTranslateObj) {
                TweenMax.killTweensOf(sw.vertualTranslateObj);
            }
        });

        const _baseSetTransition2 = sw.setTransition.bind(sw);
        const _baseSetTranslate2 = sw.setTranslate.bind(sw);
        sw.vertualTranslateObj = {x: sw.translate};
        sw.setTransition = function (duration, byController) {
            _baseSetTransition2(0, byController);
        };
        sw.setTranslate = function (translate, byController) {

            if (sw.vertualTranslateObj.x === translate) {
                sw.transitionEnd();
                return;
            }

            TweenMax.to(sw.vertualTranslateObj, Math.abs(translate - sw.vertualTranslateObj.x) * sw.params.speed / 1000000, {
                x: translate,
                ease: CustomEase.create('custom', 'M0,0,C0.12,0.37,0.2,1,1,1'),
                onStart: function () {
                    sw.transitionStart();
                },
                onUpdate: function () {
                    const x = this.target.x;
                    if (sw.params.direction === 'vertical')
                        sw.$wrapperEl.transform('translate3d(0px, ' + x + 'px, 0px)');
                    else {
                        sw.$wrapperEl.transform('translate3d(' + x + 'px, 0px, 0px)');
                        ParallaxController.update();
                    }
                },
                onComplete: function () {
                    sw.transitionEnd();

                    if (scrollTransition) return;

                    if (!isVertical && sw.el.data.lastProgressN > 2) {
                        sw.el.data.lastProgressN = 0;
                        next();
                    }
                }
            });

            _baseSetTranslate2(translate, byController);
        };
    });

    swInitiated = true;

    return this;
}



const _initScrollState = function (data) {
    data.scrollProgress = 0;
    data.maxScrollProgress = 0;
    data.scrollStage = 0;
    data.scrollFixedProgress = 0;
    data.scrollFixedProgressChanged = false;
};

const _updateScrollState = function (data, value) {
    if (typeof value === 'undefined' || data.maxScrollProgress === value)
        return data.maxScrollProgress;

    if (data.scrollProgress < value)
        data.scrollProgress = value;

    // Store the maximum value only
    if (data.maxScrollProgress > value) return data.maxScrollProgress;

    const stage = Math.floor(value / 25);
    data.maxScrollProgress = value;

    if (data.scrollStage === stage) return data.maxScrollProgress;

    data.scrollStage = stage;
    data.scrollFixedProgress = Math.round(stage * 25);
    data.scrollFixedProgressChanged = true;
    return data.maxScrollProgress;
};

function _deinitSWs() {
    _clearTweens();

    if (!swInitiated) return;

    mainSW.destroy(false, true);
    longSW.forEach(sw => {
        sw.destroy(false, true);
    });
    mainSW = null;
    longSW = [];

    swInitiated = false;
}

function _clearTweens() {
    if (typeof tweenFunc !== 'undefined') {
        tweenFunc();
        TweenMax.killDelayedCallsTo(tweenFunc);
        tweenFunc = undefined;
    }
}

function _initStatic() {
    if (staticInitiated) return;
    scrollTransition = false;

    _allow = () => {};
    _next = staticNext;
    _goto = staticGoto;
    _scrollLong = _allow;

    staticView = {};
    staticView.sections = [...document.querySelectorAll('.sections__container .section')];
    staticView.sectionsInView = staticView.sections.map(el => {
        const id = el.getAttribute('id');
        if (!id) return null;
        return InViewOffMixin(inView(`#${id}`));
    });

    staticInitiated = true;
}

function _deinitStatic() {
    if (!staticInitiated) return;

    _addStaticListeners(false);

    staticView = null;
    
    scrollTransition = false;
    staticInitiated = false;
}

function _emitChanged(index, prevIndex) {
    if (_hasOnChange)
        _onChange(index, prevIndex);
}

function _emitLongProgressChanged(index, progress) {
    if (_hasOnLongProgressChanged)
        _onLongProgressChanged(index, progress);
}

function start() {

    started = true;
    _addListeners(true);

    if (sizeMode === 'static')
        _addStaticListeners(true);

    if (swInitiated) {
        longSW.mouseEntered = true;
        mainSW.mouseEntered = true;
    }

    return this;
}

function _addListeners(b) {
    if (!b) {
        win.removeEventListener('resize', _resizeHandler);
        return;
    }
    win.addEventListener('resize', _resizeHandler);
}

function _addStaticListeners(b) {
    if (!b) {

        if (typeof staticView.updateCurrIndex !== 'undefined') TweenMax.killDelayedCallsTo(staticView.updateCurrIndex);

        while (staticView.sectionsInView.length > 0)
            staticView.sectionsInView.pop().removeAllListeners();

        return;
    }

    staticView.sectionsInView.forEach((inview, index) => {
        if (!inview) return null;

        inview.on('enter', el => {
            if (!started || !staticView) return;
            if (el.getBoundingClientRect().top > -1) {
                if (typeof staticView.updateCurrIndex !== 'undefined') TweenMax.killDelayedCallsTo(staticView.updateCurrIndex);
                staticView.updateCurrIndex = function () {
                    currIndex = index;

                    analyticsEvent('Page', 'change', 'Section: ' + staticView.sections[index].dataset.eventLabel);
                    staticView.updateCurrIndex = undefined;
                };

                TweenMax.delayedCall(0.001, staticView.updateCurrIndex);
            }

            const section = staticView.sections[index];
            if (section.classList.contains('section--type-long')) {
                let data = section.data;
                if (!data) {
                    data = {};
                    _initScrollState(data);
                }
                section.data = data;
                _injectAdditionalTest(inview);
            }
            _emitChanged(index, -1);
        });

        inview.on('exit', () => {
            if (!started) return;

            if (staticView.sections[index].classList.contains('section--type-long')) {
                _clearAdditionalTest(inview);
            }

            _emitChanged(-1, index);
        });
        inview.check();

        return inview;
    });

    const _injectAdditionalTest = inview => {
        if (inview._hasAdditionalCheck) return;
        inview._hasAdditionalCheck = true;
        inview._initialCheck = inview.check;
        inview.check = function () {

            this.elements.forEach(el => {
                const data = el.data;
                const {bottom, height} = el.getBoundingClientRect();
                const winH = SizesUtils.winHeight();

                const p = 1 - Math.min(1, Math.max(0, bottom / (height - winH)));

                _updateScrollState(data, p * 100);
                if (data.scrollFixedProgressChanged) {
                    const label = el.dataset.eventLabel;
                    analyticsEvent(`"${label}" Scroll Depth Percentage`, 'scroll', data.scrollFixedProgress);
                    // console.log(`"${label}" Scroll Depth Percentage`, 'scroll', data.scrollFixedProgress);
                    data.scrollFixedProgressChanged = false;
                }
            });

            this._initialCheck();
        }.bind(inview);
    };

    const _clearAdditionalTest = inview => {
        if (!inview._hasAdditionalCheck) return;
        inview._hasAdditionalCheck = false;
        inview.check = inview._initialCheck;
    };
}

function _resizeHandler() {

    const newSizeMode = SizeMode(true);
    _H = SizesUtils.winHeight();

    if (newSizeMode === sizeMode) return;

    sizeMode = newSizeMode;
    isVertical = sizeMode === 'vertical';

    prevIndex = currIndex;

    _deinitSWs();
    _deinitStatic();
    if (sizeMode !== 'static') {
        _initSWs();
    } else {
        _initStatic();
        _addStaticListeners(true);
    }

    _goto(prevIndex);
    _emitChanged(currIndex, prevIndex);
}

let lastStageChaneTimestamp = 0;
let _allow;
let _next;
let _goto;
let _scrollLong;



function next() {
    const t = (new Date()).getTime();
    if (t - lastStageChaneTimestamp < 1000) return this;

    _allow();
    _next();

    lastStageChaneTimestamp = t;

    return this;
}

function goto(index) {
    const t = (new Date()).getTime();
    if (t - lastStageChaneTimestamp < 1000) return this;

    _allow();
    _goto(index);

    lastStageChaneTimestamp = t;

    return this;
}

function scrollLong() {
    /* const t = (new Date()).getTime();
    if (t - lastStageChaneTimestamp < 1000) return this;*/

    _scrollLong();

    // lastStageChaneTimestamp = t;

    return this;
}

function swAllow() {
    if (!swInitiated) return;

    mainSW.allowSlideNext = true;
    mainSW.allowSlidePrev = true;
}

function swNext() {
    if (!swInitiated) return;

    mainSW.slideNext();
}

function swGoto(index) {
    if (!swInitiated) return this;

    mainSW.slideTo(index);
}

function swScrollLong() {
    if (!swInitiated) return this;
    if (!isLong) return this;

    const section = mainSW.slides[mainSW.activeIndex];
    const sw = section.data.sw;
    if (!sw) return;

    const evt = {
        wheelDelta: _delta,
        deltaY: _delta / 3,
        preventDefault: () => {}
    };

    sw.mousewheel.handleMouseEnter();
    sw.mousewheel.handle(evt);
    sw.mousewheel.handleMouseLeave();
}

function staticNext() {
    if (!staticInitiated) return;
    if (scrollTransition) return;

    _scrollBy(_H);
}


function staticGoto(index) {
    if (!staticInitiated) return this;

    _scrollTo('section' + index);
}

function _scrollTo(name) {
    if (!name || !document.getElementById(name)) return;
    _scroll('#' + name);
}

function _scrollBy(val) {
    _scroll(Math.round(SizesUtils.getWinScrollTop() + val), true);
}

function _scroll(val, smooth) {
    scrollTransition = true;
    TweenMax.to(win, 0.5, {
        scrollTo: {y: val, autoKill:false},
        ease: smooth ? Circ.easeInOut : CustomEase.create('custom', 'M0,0 C0.042,0.042 0.012,0.598 0.066,0.81 0.114,0.998 0.818,1 1,1'),
        onComplete: () => {
            scrollTransition = false;
            staticView.sectionsInView.forEach(inview => {
                inview.check();
            })
        }
    });
}

function onChange(f) {
    _hasOnChange = typeof f === 'function';
    if (!_hasOnChange) return this;
    _onChange = f;
    return this;
}

function onLongProgressChanged(f) {
    _hasOnLongProgressChanged = typeof f === 'function';
    if (!_hasOnLongProgressChanged) return this;
    _onLongProgressChanged = f;
    return this;
}


const SectionsController = {};

SectionsController.init = init.bind(SectionsController);
SectionsController.start = start.bind(SectionsController);
SectionsController.next = next.bind(SectionsController);
SectionsController.scrollLong = scrollLong.bind(SectionsController);
SectionsController.goto = goto.bind(SectionsController);
SectionsController.onChange = onChange.bind(SectionsController);
SectionsController.onLongProgressChanged = onLongProgressChanged.bind(SectionsController);

module.exports = SectionsController;


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/SectionsController.js